<template>
<div class="scroll-top" @click="onScrollTop">
  <div class="box-arrow">
    <i class="el-icon el-sub-menu__icon-arrow">
      <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"></path>
      </svg>
    </i>
  </div>
</div>

</template>
<script>
  export default {
    props: {},
    methods: {
      onScrollTop() {
        window.scrollTo({ top: 0, left: 100, behavior: 'smooth' });
      },
      showScroll() {
        this.firstLoadScroll();
        window.onscroll = function (e) {
          let distanceScrolled = document.documentElement.scrollTop;
          if (distanceScrolled < 100) {
            document.getElementsByClassName("scroll-top")[0].style.opacity  = "0";
            document.getElementsByClassName("scroll-top")[0].style.transition   = "0.5s";
          } else {
            document.getElementsByClassName("scroll-top")[0].style.opacity  = "1";
          }
        }
      },
      firstLoadScroll() {
        let distanceScrolled = document.documentElement.scrollTop;
        if (distanceScrolled < 100) {
          document.getElementsByClassName("scroll-top")[0].style.opacity  = "0";
          document.getElementsByClassName("scroll-top")[0].style.transition   = "0.5s";
        } else {
          document.getElementsByClassName("scroll-top")[0].style.opacity  = "1";
        }
      }
    },
    mounted() {
      this.showScroll();
    },
  }
</script>

<style lang="scss">
  .scroll-top {
    position: fixed;
    bottom: 28px;
    right: 0;
    width: 43px;
    height: 25px;
    z-index: 999999;
    background: #DDD8D1 0% 0% no-repeat padding-box;
    .box-arrow {
      display: flex;
      align-items: center;
      justify-self: center;
      width: 100%;
      height: 100%;
      cursor: pointer;
      i {
        width: 100%;
        color: #fff;
        transform: rotateX(180deg);
      }
    }
  }
</style>